import { IBranch } from '../../types/user'

export type SanaStatus = 'template' | 'synced' | 'failed'

export const SANA_STATUS_LABEL: Record<SanaStatus, string> = {
  template: 'Template',
  synced: 'Synced',
  failed: 'Sync failed',
}

export const SANA_STATUS_COLOR: Record<SanaStatus, string> = {
  template: '#051350',
  synced: '#3ABF77',
  failed: '#EA4968',
}

export const sanaStatus = (
  manager: IBranch['sanaLoginManager'],
): SanaStatus => {
  if (!manager?.sanaPasswordSyncedAt) return 'template'
  if (manager.sanaPasswordSyncError) return 'failed'
  return 'synced'
}
